import { render, staticRenderFns } from "./ContentTestimonials.vue?vue&type=template&id=a6681f68&scoped=true&"
import script from "./ContentTestimonials.vue?vue&type=script&lang=js&"
export * from "./ContentTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./ContentTestimonials.vue?vue&type=style&index=0&id=a6681f68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6681f68",
  null
  
)

export default component.exports